import * as React from 'react';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../application/core/DispatchProps';
import RemoveCustomerConfirmed from '../application/estimations/events/RemoveCustomerConfirmed';

interface Props {
    customerId: string;
}

class RemoveCustomer extends React.PureComponent<Props & DispatchProps> {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-title">Remove customer</div>
                <div className="popup-text">Are you sure to remove this customer?.</div>
                <button onClick={this.confirmed}>yes</button>
            </>
        );
    }

    private confirmed = (): void => {
        this.props.dispatch(new RemoveCustomerConfirmed(this.props.customerId));
    };
}

export default connect(mapDispatchToProps)(RemoveCustomer);



// WEBPACK FOOTER //
// ./src/view/RemoveCustomer.tsx